import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, StatusPill, Section, Loading, KPITile } from "../components/Common";
import { useAuth } from "../lib/auth";
import { useParams, Link } from "react-router-dom";

export default function ParentPortal() {
  const { user } = useAuth();
  const { school } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.parentOverview().then(({ data }) => setData(data)); }, []);
  if (!data) return <Loading />;
  const outstanding = (data.invoices || []).reduce((a, i) => a + (i.total - i.amount_paid), 0);
  return (
    <div data-testid="parent-portal">
      <PageHeader kicker="Parent Portal" title={`Welcome, ${user?.full_name}`} subtitle="Your family’s overview at Highlands." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <KPITile tone="dark" testId="pp-children" label="Children enrolled" value={(data.children || []).length} />
        <KPITile testId="pp-invoices" label="Invoices" value={(data.invoices || []).length} />
        <KPITile testId="pp-outstanding" label="Outstanding" value={`$${outstanding.toLocaleString()}`} />
        <KPITile testId="pp-notices" label="School notices" value={(data.notifications || []).length} />
      </div>

      <Section title="My children">
        <div className="grid md:grid-cols-2 gap-4">
          {(data.children || []).map((c) => (
            <Link key={c.id} to={`/education360/${school}/students/${c.id}`} className="hl-card p-5 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-[color:var(--hl-navy)] text-white grid place-items-center font-semibold">
                {c.first_name[0]}{c.last_name[0]}
              </div>
              <div>
                <div className="font-display font-bold text-lg tracking-tight">{c.first_name} {c.last_name}</div>
                <div className="text-xs text-slate-500">{c.year_group} · {c.house} · {c.boarding ? "Boarder" : "Day"}</div>
              </div>
            </Link>
          ))}
        </div>
      </Section>

      <Section title="Fee statements">
        <DataTable
          columns={[
            { key: "term", label: "Term" },
            { key: "total", label: "Total", render: (r) => <span className="mono">${r.total.toLocaleString()}</span> },
            { key: "amount_paid", label: "Paid", render: (r) => <span className="mono">${r.amount_paid.toLocaleString()}</span> },
            { key: "status", label: "Status", render: (r) => <StatusPill status={r.status} /> },
            { key: "due_date", label: "Due" },
          ]}
          rows={data.invoices || []}
        />
      </Section>

      <Section title="Recent notices">
        <div className="space-y-3">
          {(data.notifications || []).map((n) => (
            <div key={n.id} className="hl-card p-5">
              <div className="font-display font-bold text-base tracking-tight">{n.title}</div>
              <div className="text-sm text-slate-600 mt-1">{n.body}</div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
